function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isArray } from 'vega-util';
import { FACET_CHANNELS } from '../../channel';
import { title as fieldDefTitle } from '../../channeldef';
import { contains, getFirstDefined } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { assembleAxis } from '../axis/assemble';
import { parseGuideResolve } from '../resolve';
import { getHeaderProperty } from './common';
export function getHeaderType(orient) {
  if (orient === 'top' || orient === 'left' || isSignalRef(orient)) {
    // we always use header for orient signal since we can't dynamically make header becomes footer
    return 'header';
  }
  return 'footer';
}
export function parseFacetHeaders(model) {
  var _iterator = _createForOfIteratorHelper(FACET_CHANNELS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var channel = _step.value;
      parseFacetHeader(model, channel);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  mergeChildAxis(model, 'x');
  mergeChildAxis(model, 'y');
}
function parseFacetHeader(model, channel) {
  var facet = model.facet,
    config = model.config,
    child = model.child,
    component = model.component;
  if (model.channelHasField(channel)) {
    var _fieldDef$header;
    var fieldDef = facet[channel];
    var titleConfig = getHeaderProperty('title', null, config, channel);
    var title = fieldDefTitle(fieldDef, config, {
      allowDisabling: true,
      includeDefault: titleConfig === undefined || !!titleConfig
    });
    if (child.component.layoutHeaders[channel].title) {
      // TODO: better handle multiline titles
      title = isArray(title) ? title.join(', ') : title;
      // merge title with child to produce "Title / Subtitle / Sub-subtitle"
      title += " / ".concat(child.component.layoutHeaders[channel].title);
      child.component.layoutHeaders[channel].title = null;
    }
    var labelOrient = getHeaderProperty('labelOrient', fieldDef.header, config, channel);
    var labels = fieldDef.header !== null ? getFirstDefined((_fieldDef$header = fieldDef.header) === null || _fieldDef$header === void 0 ? void 0 : _fieldDef$header.labels, config.header.labels, true) : false;
    var headerType = contains(['bottom', 'right'], labelOrient) ? 'footer' : 'header';
    component.layoutHeaders[channel] = _defineProperty({
      title: fieldDef.header !== null ? title : null,
      facetFieldDef: fieldDef
    }, headerType, channel === 'facet' ? [] : [makeHeaderComponent(model, channel, labels)]);
  }
}
function makeHeaderComponent(model, channel, labels) {
  var sizeType = channel === 'row' ? 'height' : 'width';
  return {
    labels: labels,
    sizeSignal: model.child.component.layoutSize.get(sizeType) ? model.child.getSizeSignalRef(sizeType) : undefined,
    axes: []
  };
}
function mergeChildAxis(model, channel) {
  var child = model.child;
  if (child.component.axes[channel]) {
    var _model$component = model.component,
      layoutHeaders = _model$component.layoutHeaders,
      resolve = _model$component.resolve;
    resolve.axis[channel] = parseGuideResolve(resolve, channel);
    if (resolve.axis[channel] === 'shared') {
      // For shared axis, move the axes to facet's header or footer
      var headerChannel = channel === 'x' ? 'column' : 'row';
      var layoutHeader = layoutHeaders[headerChannel];
      var _iterator2 = _createForOfIteratorHelper(child.component.axes[channel]),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _layoutHeader$headerT;
          var axisComponent = _step2.value;
          var headerType = getHeaderType(axisComponent.get('orient'));
          (_layoutHeader$headerT = layoutHeader[headerType]) !== null && _layoutHeader$headerT !== void 0 ? _layoutHeader$headerT : layoutHeader[headerType] = [makeHeaderComponent(model, headerChannel, false)];
          // FIXME: assemble shouldn't be called here, but we do it this way so we only extract the main part of the axes
          var mainAxis = assembleAxis(axisComponent, 'main', model.config, {
            header: true
          });
          if (mainAxis) {
            // LayoutHeader no longer keep track of property precedence, thus let's combine.
            layoutHeader[headerType][0].axes.push(mainAxis);
          }
          axisComponent.mainExtracted = true;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      // Otherwise do nothing for independent axes
    }
  }
}